import 'aframe';
import 'aframe-outline';
import 'aframe-look-at-component';
import 'aframe-glow';

import React, { Component } from 'react';
import { Entity, Scene } from 'aframe-react';

export default class Scene360 extends Component {
  state = {
    linkColors: []
  };
  componentDidMount() {
    this.props.onLoad();
  }

  setLinkColor = (i, color) => {
    let linkColors = [...this.state.linkColors];
    linkColors[i] = color;
    this.setState({ linkColors });
  };

  render() {
    const { data, defaultColor } = this.props;

    const links = !!data.links
      ? data.links.map((link, i) => {
          const color = link.color || (defaultColor || '#000');
          return (
            <Entity
              geometry={{
                primitive: 'sphere',
                radius: 0.6
              }}
              look-at="#camera"
              material={{
                color: this.state.linkColors[i] || color,
                opacity: 0,
                roughness: 10
              }}
              position={link.pos}
              key={`link-from-${data.id}-${link.toId}-${i}`}
              events={{
                click: event => {
                  this.setLinkColor(i, color);
                  this.props.onLinkClick(link.toId, event);
                },
                mouseenter: event => this.setLinkColor(i, '#00ff88'),
                mouseleave: event => this.setLinkColor(i, color),
                mousedown: event => this.setLinkColor(i, '#00aa44')
              }}
            >
              <Entity
                look-at="[camera]"
                geometry={{
                  primitive: 'ring',
                  radiusInner: 0.25,
                  radiusOuter: 0.4
                }}
                material={{
                  color: this.state.linkColors[i] || color,
                  opacity: 0.75,
                  roughness: 10
                }}
              />
            </Entity>
          );
        })
      : null;

    return (
      <div style={{ width: '100%', height: '100%', background: 'black' }}>
        <Scene outline>
          <Entity
            primitive="a-camera"
            id="camera"
            look-controls={{ reverseMouseDrag: true }}
          >
            <Entity primitive="a-cursor" />
          </Entity>
          {links}

          <Entity primitive="a-sky" src={data.url} />
        </Scene>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Scene360.js